/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { ExcIceJobV1JobState } from '@interxfi/types';
import { schema } from 'normalizr';

export const EXC_ICE_JOB_V1_JOB_STATE_ENTITY_NAME = 'exc.ice.job.v1.Job';
export const excIceJobV1JobStateEntity = new schema.Entity<ExcIceJobV1JobState>(EXC_ICE_JOB_V1_JOB_STATE_ENTITY_NAME, {}, { idAttribute: 'jobId' });

